<template>
    <div class="account__block">
        <div class="d-flex d-lg-block">
            <div class="account__block_image h2 d-flex justify-content-center align-items-center">
                <div class="account__block_add_image" v-if="!isaccountroute" @click="redirectToAccount">
                    <img :src="getAvatar" alt="">
                </div>
                <template v-else>
                    <div class="account__block_add_image">
                        <input id="add_image" type="file" name="avatar" accept=".png, .jpg, .jpeg" @change="updateFile">
                        <label for="add_image">{{ get_translation_constant('text_add_photo') }}</label>
                    </div>
                </template>
                <img :src="getAvatar" alt="">
            </div>
            <div class="account__block_data">
                <div class="account__block_info d-flex justify-content-between">
                    <div class="account__full_name h_text">{{ account.first_name_latin }} {{ account.last_name_latin }}
                    </div>
                    <div class="account__code">{{ account.room_id }}</div>
                </div>
                <div class="account__block_link" v-if="!isaccountroute">
                    <a :href="accountlink">{{ get_translation_constant('text_account_management') }}</a>
                </div>
            </div>
        </div>
        <div class="account__block_wallet">
            <div class="d-flex justify-content-between">{{ get_translation_constant('text_fund_on_account') }}
                <span id="balance" >{{ account.balance }}</span></div>
<!--            <div class="d-flex justify-content-between">{{ get_translation_constant('text_orders_for_amount') }}-->
<!--                <span  id="orderAmount" >{{ account.orders_for_amount }}</span>-->
<!--            </div>-->
        </div>
        <div class="account__block_bonus">
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    {{ get_translation_constant('text_bonus') }}
                    <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                            fill="#515154"/>
                                                    </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner">
                                    <span class="tooltip__block_close"></span>
                                    <p>{{ get_translation_constant('text_invite_friend') }}</p>
                                    <p><a href="#">{{ get_translation_constant('text_learn_more_about_bonus') }}</a></p>
                                </span>
                            </span>
                        </span>
                </div>
                <span id="bonus">{{ account.bonus }}</span>
            </div>
        </div>
        <div class="account__block_wallet">
            <div class="d-flex justify-content-between">{{ get_translation_constant('text_account_sidebar_tariff_type') }}
                <span id="balance" >{{ account.tariff ? account.tariff : '-' }}</span></div>
<!--            <div class="d-flex justify-content-between">{{ get_translation_constant('text_account_sidebar_general') }}-->
<!--                <span  id="orderAmount" >{{ account.general ? account.general : '-' }}</span>-->
<!--            </div>-->
<!--            <div class="d-flex justify-content-between">{{ get_translation_constant('text_account_sidebar_individual') }}-->
<!--                <span  id="orderAmount" >{{ account.individual ? account.individual : '-' }}</span>-->
<!--            </div>-->
        </div>
        <div class="account__block__actions">
            <div class="d-flex d-lg-block">
                <a class="btn btn__medium btn__block btn__blue" href="#" data-bs-toggle="modal"
                   data-bs-target="#balanceRefill">{{ get_translation_constant('text_refill_account') }}
                </a>
                <a class="btn btn__medium btn__block btn__gray_border"
                   :href="logoutlink">{{
                        get_translation_constant('text_logout')
                    }}</a>
            </div>
        </div>
        <div class="account__block_trigger"></div>
        <!-- Modal balanceRefill -->
        <div class="modal fade modal__custom" id="balanceRefill" tabindex="-1" role="dialog"
             aria-labelledby="balanceRefillTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="balanceRefillTitle">
                            {{ get_translation_constant('text_replenishment_of_balance') }}</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                id="balanceRefillClose"></button>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="row align-items-end">
                                <div class="col-12 col-lg-auto">
                                    <div class="form__col">
                                        <label>{{ get_translation_constant('text_enter_amount') }} ($)</label>
                                        <input class="form__control w-160 type_tel" id="summ" name="summ"
                                               placeholder="0" type="tel" v-model="form.refillAmount"
                                               @input="form.refillAmount = Math.min(Number(form.refillAmount), 10000)">
                                    </div>
                                </div>
                                <div class="col-12 col-lg-auto">
                                    <div class="form__col">
                                        <input class="btn btn__large btn__blue no_width refill__success" type="button"
                                               :value="get_translation_constant('text_refill')"
                                               @click.prevent="refillBalance"
                                        >
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <alert-modal :title="modalTitle" :type="modalType" :message="modalMessage"></alert-modal>
    </div>
</template>

<script>
import account from "./Account";

export default {
    name: "Sidebar",
    props: {
        account: {
            type: [Object]
        },
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        cities: {
            type: [Object, Array]
        },
        genders: {
            type: [Object, Array]
        },
        isaccountroute: {
            type: [Boolean],
            default: false
        },
        accountlink: {
            type: [String]
        },
        logoutlink: {
            type: [String]
        },
        refillaccountlink: {
            type: [String]
        },
    },
    data() {
        return {
            errors: [],
            form: {
                avatar: null,
                refillAmount: 0
            },
            modal: {
                type: 'success',
                title: '',
                message: ''
            },
            trigger: {
                successRefill: false,
            },
        }
    },
    methods: {
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];
        },
        get_translation_constant(key) {
            const list = Array.isArray(this.translations) ? this.translations : [];
            return list.find(item => item?.key === key)?.value?.[this.lng] ?? key;
        },
        updateFile(e) {
            this.createImage(e.target.files[0]);
            this.$emit('AvatarChanged', e.target.files[0])
        },
        redirectToAccount() {
            window.location.href = this.accountlink;
        },
        createImage(file) {
            let image = new Image();
            let reader = new FileReader();
            reader.onload = (e) => {
                this.form.avatar = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        refillBalance() {
            const amount = Number(this.form.refillAmount);

            if (amount > 10000) {
                this.form.refillAmount = 10000;

                this.modal.title = this.get_translation_constant('text_refill_failure_title');
                this.modal.type = 'error';
                this.modal.message = 'Maximum allowed amount is $10,000';

                setTimeout(() => {
                    document.getElementById('AlertModalBtn').click()
                }, 200);

                return;
            }

            let refillRequest = {
                amount: amount,
                user_id: this.account.id,
                success_url: this.accountlink,
                failed_url: this.accountlink,
            }
            axios.post(this.refillaccountlink, refillRequest).then(response => {
                if (response.status === 200) {
                    window.location.href = decodeURIComponent(response.data.redirectUrl);
                    //clear form
                    // this.modal.title = this.get_translation_constant('text_refill_success_title');
                    // this.modal.type = 'success';
                    // this.modal.message = this.get_translation_constant('text_refill_success')
                    // this.trigger.successRefill = true;
                    // this.errors = [];
                    // setTimeout(() => {
                    //     document.getElementById('balanceRefillClose').click()
                    //     this.form.refillAmount = 0;
                    // }, 200)

                    //TODO emit update balance or bonus
                }
            }).catch(error => {
                if (typeof error.response.status !=='undefined'){
                    if (error.response.status === 422) {

                        this.errors = error.response.data.errors;
                        this.trigger.successRefill = false;
                        /* this.modal.title = 'Error Add message';
                         this.modal.type = 'error';
                         this.modal.message = 'Error Add message'
                         setTimeout(() => {
                              this.alertModal.click();
                         }, 200) */
                    }
                    if (error.response.status === 500) {

                        this.errors = error.response.data.errors;
                        this.modal.title = this.get_translation_constant('text_refill_failure_title');
                        this.modal.type = 'error';
                        this.modal.message = this.get_translation_constant('text_refill_failure')
                        this.trigger.successRefill = false;
                        setTimeout(() => {
                            document.getElementById('AlertModalBtn').click()
                        }, 200)
                    }
                }
            });
        },
    },
    mounted() {
        const balanceModal = document.getElementById('balanceRefill')
        balanceModal.addEventListener('hide.bs.modal', () => {
            console.log('hide')
        })
    },
    computed: {
        getAvatar() {
            if (this.form.avatar !== null) {
                return this.form.avatar;
            }
            return this.account.avatar;
        },
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
    },

}
</script>

<style scoped>

</style>
